module.exports = new __parcel__URL__("vibe-4-mobile.3771172e.json").toString();